"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWorker = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var slice_1 = require("../store/slice");
var filterSelectors_1 = require("../filter/filterSelectors");
var initAttributeSaga_1 = require("./initAttributeSaga");
var initSelectionSaga_1 = require("./initSelectionSaga");
var initElementsPageSaga_1 = require("./initElementsPageSaga");
var initTotalCount_1 = require("./initTotalCount");
/**
 * @internal
 */
function initWorker() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(slice_1.actions.init.match, initSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.initWorker = initWorker;
function initSaga(action) {
    var correlation, hiddenElements, error_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                correlation = action.payload.correlation;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 10, 12, 16]);
                return [4 /*yield*/, effects_1.put(slice_1.actions.initStart({ correlation: correlation }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(filterSelectors_1.selectHiddenElements)];
            case 3:
                hiddenElements = _a.sent();
                if (!((hiddenElements === null || hiddenElements === void 0 ? void 0 : hiddenElements.length) > 0)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(initAttributeSaga_1.initAttributeSaga, correlation)];
            case 4:
                _a.sent();
                // these need the attribute loaded for the hiddenElements to work
                return [4 /*yield*/, effects_1.all([
                        effects_1.call(initSelectionSaga_1.initSelectionSaga, correlation),
                        effects_1.call(initElementsPageSaga_1.initAttributeElementsPageSaga, correlation),
                        effects_1.call(initTotalCount_1.initTotalCountSaga, correlation),
                    ])];
            case 5:
                // these need the attribute loaded for the hiddenElements to work
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.all([
                    effects_1.call(initAttributeSaga_1.initAttributeSaga, correlation),
                    effects_1.call(initSelectionSaga_1.initSelectionSaga, correlation),
                    effects_1.call(initElementsPageSaga_1.initAttributeElementsPageSaga, correlation),
                    effects_1.call(initTotalCount_1.initTotalCountSaga, correlation),
                ])];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [4 /*yield*/, effects_1.put(slice_1.actions.initSuccess({ correlation: correlation }))];
            case 9:
                _a.sent();
                return [3 /*break*/, 16];
            case 10:
                error_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(slice_1.actions.initError({ error: error_1, correlation: correlation }))];
            case 11:
                _a.sent();
                return [3 /*break*/, 16];
            case 12: return [4 /*yield*/, effects_1.cancelled()];
            case 13:
                if (!_a.sent()) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.all([effects_1.put(slice_1.actions.initCancel({ correlation: correlation }))])];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [7 /*endfinally*/];
            case 16: return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=initSaga.js.map